const storage = {
    not_configured: 'Nie skonfigurowano dostawcy magazynu.',
    missing_parameter: 'Brak parametru {{parameter}} dla dostawcy magazynu.',
    upload_error: 'Nie udało się przesłać pliku do dostawcy magazynu.',
};
export default Object.freeze(storage);
